import { HeroEventProps } from '@sbercloud/uikit-product-site-hero';

import { EventOrWebinarType } from '../../../../types/backendContent';
import { Audience } from '../constants';

const isAudience = (
  audience: EventOrWebinarType['audience'],
): audience is NonNullable<HeroEventProps['audience']> => {
  return Boolean(Audience.find((a) => a.value === audience));
};

export const getAudience = ({
  audience,
}: EventOrWebinarType): HeroEventProps['audience'] => {
  return audience && isAudience(audience) ? audience : undefined;
};
